import type { FC } from 'react';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import './styles/styles.css';
import Header from '../../Header';
import { PackagesTable } from '../../Tables/Packages';

export const Packages: FC = () => {
  return (
    <Container fluid className="reservation-list-container">
      <Header title="Add-ons" />
      <PackagesTable />
    </Container>
  );
};
